import { MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "+919068155122";

export default function WhatsAppButton() {
  const handleClick = () => {
    const message = encodeURIComponent("Hello! I'm interested in your embroidery services.");
    window.open(`https://wa.me/${WHATSAPP_NUMBER.replace('+', '')}?text=${message}`, '_blank');
  };

  return (
    <button
      onClick={handleClick}
      data-testid="whatsapp-float-btn"
      className="whatsapp-float"
      aria-label="Contact on WhatsApp"
    >
      <MessageCircle className="w-6 h-6" />
    </button>
  );
}
